































import { Vue, Component, Prop } from "vue-property-decorator";
import { ITemplate } from "@/models/templates";

@Component
export default class TemplatePreviewDropdown extends Vue {
  // Props
  @Prop({ default: undefined })
  public template?: ITemplate;
}
